var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"HaNXVdto0Zp_2_9R2X-bx"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';
import { replayIntegration } from '@sentry/replay';
import { BrowserTracing } from '@sentry/tracing';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://b6efe052560c2241bfa4cb16ae16b6a5@o4509270402400256.ingest.de.sentry.io/4509270407446608',
    sendDefaultPii: true,
    tags: { 'app.runtime': 'client' },
    tracesSampleRate: 0.1, // Adjust this value (0.0 to 1.0)
    environment: 'admin',
    integrations: [
      replayIntegration({ maskAllText: false, blockAllMedia: false }),
      new BrowserTracing({
        routingInstrumentation: Sentry.nextjsRouterInstrumentation,
      }),
    ],
    // Session Replay
    replaysSessionSampleRate: 0.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}
